const modules = [
 'ngAnimate',
 'yaMap',
 'cian.ui.button',
 'cian.ui.checklist',
 'cian.ui.selectpopup',
 'cian.regionCityBrowser',
 'cian.metroBrowser',
 'cian.highwayBrowser',
 'cian.dealTypeBrowser',
 'cian.offerTypeBrowser',
 'cian.roomsBrowser',
 'cian.districtBrowser',
 'cian.advancedBrowser',
 'cian.geoInput',
 'cian.mapDraw',
 'cian.filterTag',
 'userService',
 'cian.newbuild.filter',
 'cian.regionUtils',
 'cian.serp'
];

if (window.Raven) {
  modules.push('ngRaven');
}

angular.module('cian.filter', modules)
.config(["$interpolateProvider", "$locationProvider", "$compileProvider", 'StatsServiceProvider', 'yaMapSettingsProvider', function($interpolateProvider, $locationProvider, $compileProvider, StatsServiceProvider, yaMapSettingsProvider) {
  if (window.performance && window.performance.mark) {
    window.performance.mark('cserp.angular-run');
  }
  StatsServiceProvider.setMetric('angularRun');
  $interpolateProvider.startSymbol('{$');
  $interpolateProvider.endSymbol('$}');
  $locationProvider.html5Mode({
    enabled: true,
    requireBase: false
  });
  $compileProvider.debugInfoEnabled(false);
  // По умолчанию библиотека для ангуляра выставляет порядок longlat,
  // а в самих яндекс картах по умолчанию наоборот latlong
  // Это строка кода необязательная, решил явно указать порядок координат.
  yaMapSettingsProvider.setOrder('longlat');
}])

// Отправляем метрики загрузки страницы
.run(['$timeout', 'StatsService', function($timeout, StatsService) {
  $timeout(function() {
    // В этот момент происходит отрисовка после компиляции всех директив
    if (window.performance && window.performance.mark) {
      window.performance.mark('cserp.application');
    }
    StatsService.setMetric('applicationStart');
    StatsService.sendStats('newserp');
  })
}])

// Если уходим с новой выдачи, то обновляем страницу
.run([
  '$rootScope',
  '$window',
  '$log',
  ($rootScope, $window, $log) => {
    const allowedPaths = [
      'cat.php',
      'kupit-',
      'snyat-',
    ];
    const urlParser = $window.document.createElement('a');
    const urlIsSerp = url => {
      urlParser.href = url;
      const path = urlParser.pathname.replace('/', '');
      return allowedPaths.some(p => path.indexOf(p) === 0)
    };

    $rootScope.$on('$locationChangeSuccess', (event, newUrl, oldUrl) => {
      if (newUrl !== oldUrl && !urlIsSerp(newUrl)) {
        $log.warn(`Обновляем страницу, т.к. уходим с выдачи на ${newUrl}`);
        $rootScope.offersLoading = true;
        $window.location.reload();
      }
    });
  }
]);

angular.module('cian.filter')
  .controller('OldFiltersCtrl', [
    '$rootScope',
    'SerpListService',
    ($rootScope, SerpListService) => {
      const ctrl = {};

      ctrl.getLink = () =>
        SerpListService.getFullUrl(SerpListService.URL_CONTEXTS.OLD_FILTERS);

      ctrl.go = () => {
        // Показываем прелоадер
        $rootScope.offersLoading = true;

        ca('event', {
          name: 'oldevent',
          category: 'OldFilters',
          action: 'click'
        });
      };

      return ctrl;
    }
  ]);

angular.module('cian.filter')
.directive('money', function() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ctrl) {
      element.bind('keyup', () => {
        const inputVal = element.val();
        const formattedVal = _splitNumber(inputVal);

        if (formattedVal !== inputVal) {
          const initialCaretPos = element[0].selectionStart;

          element.val(formattedVal);
          element.triggerHandler('input');

          // Сдвигаем каретку на столько символов, сколько прибавилось к тексту
          // (например, 2, если добавилось число и пробел перед ним)
          const newCaretPos = initialCaretPos + (formattedVal.length - inputVal.length);
          element[0].setSelectionRange(newCaretPos, newCaretPos);
        }
      });

      function trimStringToNumbers (s) {
        return s.replace(/[^\d]/g, '');
      }

      function _splitNumber(num) {
        num += '';
        num = trimStringToNumbers(num);
        if (!num) return '';
        num = Math.ceil(num * 1) + '';

        var iPos = num.length - 3,
            sRes = '';

        while (iPos > 0) {
            sRes = ' ' + num.substr(iPos, 3) + sRes;
            iPos -= 3;
        }
        sRes = num.substr(0, iPos + 3) + sRes;

        return sRes;
      }

      ctrl.$parsers.push(
        function (value) {
          if (ctrl.$isEmpty(value)) {
            return value;
          }

          value = trimStringToNumbers(value.toString());
          return parseInt(value, 10) || null;
        }
      );
    }
  };
});

/**
 * items = [{
 *   text: 'Панельный',
 *   value: 1
 * },
 * {
 *   text: 'Кирпичный',
 *   value: 2
 * }]
 *
 * source – object_types: {
              type: 'terms',
              value: [1]
            }
 */

angular.module('cian.filter')
.directive('terms', function() {
  return {
    require: '?ngModel',
    scope: {
      items: '=',
      source: '=',
      onChange: '&'
    },
    template: `
      <div class="filter__button-group">
        <div
          class="s-button"
          ng-repeat="item in items track by item.value"
          ng-class="{\'s-button_active\' : source.value.indexOf(item.value) > -1}"
          ng-click="toggle(item)"
        >
          <div class="s-button__text">{$ ::item.text $}</div>
        </div>
      </div>
    `,
    link: function(scope, element, attrs, ngModel) {
      var isRadio = attrs.behavior === 'radio';

      scope.toggle = function(item) {
        if (isRadio) {
          if (ngModel) {
            ngModel.$modelValue = [item.value];
          } else {
            scope.source.value = [item.value];
          }
        } else {
          scope.source.value = scope.source.value || [];

          var idx = scope.source.value.indexOf(item.value);

          if (idx > -1) {
            scope.source.value.splice(idx, 1);
          } else {
            scope.source.value.push(item.value);
          }
        }
        scope.onChange();
      };
    }
  };
});

angular.module('cian.filter')
.directive('term', function () {
  return {
      scope: {
        text:         '@',
        source:       '=',
        behavior:     '@',
        onChange:     '&'
      },
      require: '?ngModel',
      restrict: 'E',
      replace: true,
      template: ['<div class="s-button" ng-class="{\'s-button_active\': isActive()}">',
                  '<div class="s-button__text">{$ text $}</div>',
                 '</div>'].join(''),
      link: function(scope, elem, attrs, modelCtrl) {
        var isOpposite = scope.$eval(attrs.opposite),
            isBoth = scope.$eval(attrs.both),
            isRequired = angular.isDefined(attrs.cianRequired);

        var updateView;

        if (attrs.behavior === 'checkbox') {
          scope.isActive = function() {
            if (isOpposite) {
              return scope.source && scope.source.value === false;
            } else {
              return scope.source && scope.source.value === true;
            }
          };

          updateView = function() {
            if (!isOpposite) {
              if (typeof scope.source.value === 'boolean') {
                if (scope.source.value === true) delete scope.source.value;
                else scope.source.value = true;
              } else {
                scope.source.value = true;
              }
            } else {
              if (typeof scope.source.value === 'boolean') {
                if (scope.source.value === true) scope.source.value = false;
                else delete scope.source.value;
              } else {
                scope.source.value = false;
              }
            }
          };

          elem.bind('click', function() {
            scope.$apply(function() {
              updateView();
              if (typeof scope.onChange === 'function') scope.onChange({source: scope.source});
            });
          });
        } else if (attrs.behavior === 'radio') {
          scope.isActive = function() {
            return scope.source && scope.source.value === attrs.value;
          };

          updateView = function() {
            if (!isRequired && scope.source.value === attrs.value) {
              if (attrs.defaultValue) {
                scope.source.value = attrs.defaultValue;
              } else {
                delete scope.source.value;
              }
            } else {
              scope.source.value = attrs.value;
            }
          }

          elem.bind('click', function() {
            scope.$apply(function() {
              updateView();
              if (typeof scope.onChange === 'function') scope.onChange({source: scope.source});
            });
          });
        }
      }
    };
});

angular.module('cian.filter')
.directive('words', ["$timeout", function ($timeout) {
  return {
      scope: {
        source: '=',
        placeholder: '@?',
        onChange: '&'
      },
      restrict: 'E',
      replace: true,
      controller: ["$scope", function($scope) {
        $scope.add = function() {
          if (!$scope.text) {
            $scope.focus();
            return;
          }

          $scope.source = $scope.source || [];

          if ($scope.source.indexOf($scope.text) < 0) {
            $scope.source.push($scope.text);
            if (typeof $scope.onChange === 'function') $scope.onChange();
          }

          $scope.text = '';
          $scope.focus();
        };

        $scope.remove = function(text, $event){
          // Prevent popup closing
          $event.stopPropagation();

          var idx = $scope.source.indexOf(text);

          if (idx > -1) {
            $scope.source.splice(idx, 1);
            if (typeof $scope.onChange === 'function') $scope.onChange();
          }
        };
      }],
      template: require('../../../../serp/directives/words/words.html'),
      link: function(scope, elem, attrs, modelCtrl) {
        scope.isNegative = 'negative' in attrs;

        elem.find('input').bind('keydown', function(e) {
          if (e.which === 13) {
            scope.$apply(function() {
              scope.add();
            });
          }
        });

        scope.focus = function() {
          $timeout(function() {
            elem.find('input')[0].focus();
          });
        };


      }
    }
  }]
);



// WEBPACK FOOTER //
// ./src/components/filter/src/scripts/cian.filter.js